"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCometChatUserData = toCometChatUserData;
exports.getUID = getUID;
const URI_1 = require("lincd/lib/utils/URI");
const Prefix_1 = require("lincd/lib/utils/Prefix");
function toCometChatUserData(account, userData = {}) {
    var _a;
    let person = account.accountOf;
    //currently we support person to define avatar, default is account avatar (getAvatar is used in profilePlus Person shape)
    let avatar;
    if (person['avatar']) {
        avatar = person['avatar'];
    }
    else if (person['getAvatar']) {
        avatar = (_a = person['getAvatar']()) === null || _a === void 0 ? void 0 : _a.contentUrl;
    }
    if (!avatar) {
        avatar = account === null || account === void 0 ? void 0 : account.avatar;
    }
    if (avatar) {
        avatar = avatar.replace(/\s/g, '%20');
    }
    let userName;
    if (person.givenName && person.familyName) {
        userName = `${person.givenName} ${person.familyName}`;
    }
    else if (person.givenName && !person.familyName) {
        userName = person.givenName;
    }
    else if (person.name) {
        userName = person.name;
    }
    else {
        userName = `user-${person.identifier}`; // example: user-1234
    }
    return Object.assign({ uid: getUID(person), 
        //we assume person is a Foaf person or Schema person, which will have a given name or name
        name: userName, avatar, metadata: {
            uri: person.uri,
        } }, userData);
}
function getUID(user) {
    return URI_1.URI.sanitize(Prefix_1.Prefix.toPrefixed(user.uri));
}
//# sourceMappingURL=User.js.map